import { BaseDialog } from "./dialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { submitInvoiceToKsef } from "@/service/weexpertService";
import { useMutation } from "react-query";
import { toast } from "../ui/use-toast";
import SendIcon from '@mui/icons-material/Send';

export default function InvoiceSendKsefPopup({ id, invoiceId, className, icon: iconProp }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const mutation = useMutation({
    mutationFn: () => submitInvoiceToKsef(id),
    onSuccess: (response) => {
      const ksefNumber = response.data?.ksefNumber;
      toast({
        title: t("invoices:ksef_submit_success"),
        description: ksefNumber ? `KSeF: ${ksefNumber}` : undefined,
      });
      setOpen(false);
    },
    onError: (error) => {
      const message = error.response?.data?.error || error.response?.data?.message || t("invoices:ksef_submit_error");
      toast({
        title: t("invoices:ksef_submit_error"),
        description: message,
        variant: "destructive",
      });
    },
  });

  return (
    <BaseDialog
      dialogTitle={`${t('invoices:ksef_submit_title')}: ${invoiceId}`}
      buttonText={t("invoices:button_send_ksef")}
      open={open}
      setOpen={setOpen}
      className={className}
      icon={iconProp !== undefined ? iconProp : <SendIcon fontSize="small" className="mr-1" />}
    >
      <div className="max-w-[400px] flex flex-col items-end pt-4">
        <div className="w-full pb-4 text-gray-600">
          {t("invoices:ksef_submit_confirm")}
        </div>
        <Button
          disabled={mutation.isLoading}
          onClick={() => mutation.mutate()}
        >
          {t("invoices:button_send_ksef")}
        </Button>
      </div>
    </BaseDialog>
  );
}
